import * as Action from "../action/run_monitor_compare_analyze.action";

const initState = {
    selectedNode: { // 选择的树节点
        superiorId: null,
        title: null
    },
    curves: [],
    chosenItem: [],
    isLoading: false,
    treeId: ""
}
/**
 * 对比分析 reducer
 */
const compareAnalyzeReducer = (state = initState, action) => {
    switch (action.type) {
        case Action.RUN_MONITOR_COMPARE_ANALYZE_TABLE_IS_LOADING: // 对比分析图表是否加载中
            return {...state, isLoading: action.isLoading}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_SET_SELECTED_NODE: // 设置选择的数据节点
            return {...state, selectedNode: {superiorId: action.superiorId, title: action.title}}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_SET_CURVES_DATA:   // 设置曲线数据
            return {...state, curves: [...state.curves, {item: action.item, data: action.data}]}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_ADD_CHOSEN_ITEM: // 添加对比分析项
            return {...state, chosenItem: [...state.chosenItem, action.item]}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_DELETE_CHOSEN_ITEM: // 移除选择项
            return {...state, chosenItem: state.chosenItem.filter(item => item.id != action.itemId), curves: state.curves.filter(obj => obj.item.id != action.itemId)}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_SET_TREE_ID: // 设置treeId
            return {...state, treeId: action.treeId}
        case Action.RUN_MONITOR_COMPARE_ANALYZE_RESET_CURVES_DATA: // 重置曲线数据
            return initState
        default: return{...state};
    }
}

export default compareAnalyzeReducer;
